import {
  Box,
  Button,
  Flex,
  Heading,
  ListItem,
  Modal,
  ModalContent,
  ModalFooter,
  Text,
} from '@modusign/design-system';
import { useGetWorkspaceSurvey } from '@modusign/openapi-client-user';
import { useDispatch } from 'react-redux';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { modalOpen } from '@app/store/modal/actions';

import workspaceImage from './workspace.gif';

interface ChangePrivateWorkspaceToPublicWorkspaceConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ChangePrivateWorkspaceToPublicWorkspaceConfirmModal({
  onCancel,
  onConfirm,
}: ChangePrivateWorkspaceToPublicWorkspaceConfirmModalProps) {
  const workspaceId = useWorkspaceId();
  const dispatch = useDispatch();

  const {
    data: workspaceSurvey,
    isLoading: isWorkspaceSurveyFetchLoading,
    isError: isWorkspaceSurveyFetchError,
  } = useGetWorkspaceSurvey(workspaceId, { query: { enabled: !!workspaceId } });

  return (
    <Modal isOpen maxWidth="sm" onClose={onCancel}>
      <ModalContent gap={7}>
        <Flex alignItems="center" flexDirection="column" gap={4}>
          <Text color="#F3AF00" fontSize="16px" fontWeight="bold">
            공용 워크스페이스
          </Text>
          <Heading>멤버들과 시작하는 체계적인 계약 관리</Heading>
          <Text as="p" color="textNeutralSlightlyLight" textAlign="center">
            문서·템플릿을 멤버들과 공유하고, 멤버별 세분화된 권한 제어로 <br />
            안전하게 계약을 관리할 수 있습니다.
          </Text>
        </Flex>
        <Box as="img" src={workspaceImage} />
        <Flex
          as="ul"
          bg="boxBackgroundNeutralBase"
          border="1px solid"
          borderColor="boxBorderNeutralBase"
          flexDirection="column"
          gap={3}
          px={6}
          py={7}
        >
          <ListItem>모든 데이터가 공용 워크스페이스로 이전됩니다.</ListItem>
          <ListItem>전환 후에는 모든 서명 문서가 공용 워크스페이스에 만들어집니다.</ListItem>
        </Flex>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onCancel}>취소</Button>
        <Button
          disabled={isWorkspaceSurveyFetchLoading}
          ml={3}
          variant="primary"
          onClick={() => {
            // 설문 조회에 에러가 났거나, 설문을 다 한 경우에는 설문 없이 바로 공용 웤스로 전환
            if (
              isWorkspaceSurveyFetchError ||
              (workspaceSurvey &&
                workspaceSurvey.survey.companyCategory &&
                workspaceSurvey.survey.companyName &&
                workspaceSurvey.survey.companyScale &&
                workspaceSurvey.survey.department &&
                workspaceSurvey.survey.expectedStartTime &&
                workspaceSurvey.survey.expectedUsage &&
                workspaceSurvey.survey.jobRole &&
                workspaceSurvey.survey.purpose &&
                workspaceSurvey.survey.userType)
            ) {
              onConfirm();
              return;
            }
            // 그렇지 않을 경우 설문을 띄움
            dispatch(
              modalOpen('WELCOME_SURVEY_MODAL', { onSubmit: onConfirm, toPublicWorkspace: true })
            );
          }}
        >
          공용 워크스페이스로 전환
        </Button>
      </ModalFooter>
    </Modal>
  );
}
